class MegaMenuPanelGroup {
  constructor(container) {
    this.container = container;
    this.toggles = Array.from(container.querySelectorAll('[data-mega-menu-toggle]'));
    if (this.toggles.length === 0) return;

    this.panels = Array.from(container.querySelectorAll('[data-mega-menu-panel]'));
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => this.activate(toggle));
    });
  }

  activate(toggle) {
    const targetId = toggle.getAttribute('data-target');

    this.toggles.forEach((otherToggle) => {
      const isActive = otherToggle === toggle;
      otherToggle.classList.toggle('is-active', isActive);
      otherToggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === targetId);
    });
  }
}

document.querySelectorAll('.mega-menu__content').forEach((content) => new MegaMenuPanelGroup(content));